import { ThemeProvider } from 'styled-components'

import { navPurple } from '@navinc/base-react-components'

export const AppThemeProvider = function AppThemeProvider({ children }) {
  return <ThemeProvider theme={navPurple}>{children}</ThemeProvider>
}
